// Последние ответы экранов «Кухни» в памяти вкладки браузера: при возврате на вкладку «Заказы | Стоп-лист»
// или к уже открытому ресторану — сразу прежние данные, свежие подменяются на месте фоновым запросом.
// Ключ — с токеном и сервером (другой пользователь или сервер не увидит чужое); старше 5 минут — не показываем.
// Не localStorage: после перезагрузки страницы — обычная загрузка.
const MAX_AGE_MS = 5 * 60 * 1000;
const MAX_ENTRIES = 40;

const entries = new Map();

export const cacheKey = (...parts) => JSON.stringify(parts);

export function readCache(key) {
  const entry = entries.get(key);
  if (!entry) return null;
  if (Date.now() - entry.at > MAX_AGE_MS) {
    entries.delete(key);
    return null;
  }
  return entry.value;
}

export function writeCache(key, value) {
  entries.delete(key); // в конец — самый свежий
  entries.set(key, { value, at: Date.now() });
  if (entries.size > MAX_ENTRIES) entries.delete(entries.keys().next().value);
}
